import { createTenantBroadcastNotification } from "../../../api/broadcastNotifications";

export type NotifType = "announcement" | "event" | "system" | "personal" | "signature_remind";
export type NotifStatus = "sent" | "draft" | "scheduled";
export type TargetGroup =
  | "all"
  | "active"
  | "new"
  | "vip"
  | "unsigned"
  | "level_normal"
  | "level_premium"
  | "level_director"
  | "activity_enrolled"
  | "activity_not_enrolled";

export interface StoredNotification {
  id: string;
  title: string;
  content: string;
  type: NotifType;
  status: NotifStatus;
  targetGroup: TargetGroup;
  targetCount: number;
  readCount: number;
  createdAt: string;
  sentAt?: string;
  scheduledAt?: string;
  relatedFileId?: string;
  relatedActivityId?: string;
  relatedActivityTitle?: string;
}

const formatNow = () => {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const notificationStore = {
  async sendSignatureReminder(
    tenantLegacyId: string,
    fileName: string,
    fileId: string,
    unsignedCount: number,
  ): Promise<void> {
    await createTenantBroadcastNotification(tenantLegacyId, {
      title: `请及时签署：${fileName}`,
      content: `协会文件「${fileName}」需要您签署确认。目前仍有 ${unsignedCount} 位会员尚未完成签署，请登录会员服务页面完成签署。逾期可能影响您的活动报名资格，请尽快处理。`,
      type: "signature_remind",
      status: "sent",
      targetGroup: "unsigned",
      targetCount: unsignedCount,
      readCount: 0,
      sentAt: formatNow(),
      relatedFileId: fileId,
    });
  },

  async sendMemberApprovalNotif(
    tenantLegacyId: string,
    memberLegacyId: string,
    memberName: string,
    levelName: string,
    expireDate: string,
    annualFee?: number,
  ): Promise<void> {
    const mid = memberLegacyId.trim();
    if (!mid) return;
    const feeNote = annualFee ? `年费为 ¥${annualFee}，` : "";
    await createTenantBroadcastNotification(tenantLegacyId, {
      title: `🎉 欢迎加入！您的会员申请已通过`,
      content: `亲爱的 ${memberName}，您的入会申请已审核通过！您已被授予「${levelName}」资格，${feeNote}会员有效期至 ${expireDate}。欢迎积极参与协会各项活动！`,
      type: "personal",
      status: "sent",
      targetGroup: "new",
      targetCount: 1,
      readCount: 0,
      sentAt: formatNow(),
      /** 与 feedback:/lottery: 一致：仅 relatedFileId 对应会员在小程序/H5 收件箱可见 */
      relatedActivityId: "enrollment:approved",
      relatedFileId: mid,
    });
  },

  async sendRenewalApprovalNotif(
    tenantLegacyId: string,
    memberName: string,
    levelName: string,
    newExpire: string,
    annualFee: number,
  ): Promise<void> {
    await createTenantBroadcastNotification(tenantLegacyId, {
      title: `✅ 续费成功，会员有效期已延长`,
      content: `亲爱的 ${memberName}，您的「${levelName}」续费申请已审核通过！年费 ¥${annualFee} 已确认收讫，会员有效期已成功延长至 ${newExpire}。感谢您对协会的支持，期待与您并肩前行！`,
      type: "personal",
      status: "sent",
      targetGroup: "active",
      targetCount: 1,
      readCount: 0,
      sentAt: formatNow(),
    });
  },
};
